import type { User } from '@takeshape/schema';
import { DISMISS_MESSAGE, SHOW_MESSAGE } from './action-types.js';
import type { MessageType } from './types.js';

export type MessageAction = {
  type: string;
  meta?: {
    type?: MessageType;
    timeout?: number;
    user?: User;
  };
  payload?: string;
};

export function showMessage(type: MessageType, message: string, timeout?: number): MessageAction {
  return {
    type: SHOW_MESSAGE,
    meta: { type, timeout },
    payload: message
  };
}

export type UserMessageProps = {
  type: MessageType;
  message: string;
  timeout: number;
  user?: User;
};

export function showUserMessage({ type, message, timeout, user }: UserMessageProps): MessageAction {
  return {
    type: SHOW_MESSAGE,
    meta: { type, timeout, user },
    payload: message
  };
}

export function dismissMessage(): MessageAction {
  return {
    type: DISMISS_MESSAGE
  };
}
